import { useContext } from 'react'

import StandaloneViewportContext from '@contexts/standaloneViewport'
import { ViewportTypeValues } from '@hooks/useViewport/types'

const useStandaloneViewportType = (): ViewportTypeValues | undefined =>
  useContext(StandaloneViewportContext)

export default useStandaloneViewportType
